import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { defaultHttp } from 'utils/http';
import { apiRoutes } from 'routes/api';
import { handleErrorResponse } from 'utils/index';
import { MailOutlined } from '@ant-design/icons';

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const onSubmit = (values) => {
    setLoading(true);

    defaultHttp
      .post(apiRoutes.forgot_password, {
        email: values.email,
      })
      .then(() => {
        setEmailSent(true);
      })
      .catch((error) => {
        handleErrorResponse(error);
        setLoading(false);
      });
  };

  return (
    <>
      <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl text-left text-opacity-30 tracking-wide mb-4">
        Forgot Password
      </h1>
      {emailSent ? (
        <div className="text-center text-green-600">
          A link has been sent to your email. Please check your email.
        </div>
      ) : (
        <Form
          className="space-y-4 md:space-y-6"
          form={form}
          name="forgot-password"
          onFinish={onSubmit}
          layout="vertical"
          requiredMark={false}
          initialValues={{}}
        >
          <div>
            <Form.Item
              name="email"
              label={
                <p className="block text-sm font-medium text-gray-900">Email</p>
              }
              rules={[
                {
                  required: true,
                  message: 'Please enter your email',
                },
                {
                  type: 'email',
                  message: 'Invalid email address',
                },
              ]}
            >
              <Input prefix={<MailOutlined className="text-gray-400 mr-2" />} placeholder="abc@gmail.com" className="py-3 px-4 text-base" style={{ borderRadius: '8px' }} />
            </Form.Item>
          </div>
          <div className="text-center flex flex-col justify-center items-center gap-4">
            <Button
              className="mt-4 bg-primary bg-primary h-12 text-lg"
              block
              loading={loading}
              type="primary"
              size="large"
              htmlType="submit"
            >
              Send Reset Link
            </Button>
            <a href="/login" className="text-sm text-blue-600 hover:underline">
              Back to Login
            </a>
          </div>
        </Form>
      )}
    </>
  );
};

export default ForgotPassword;
